import Axios from "axios";

const submitSiteVisitReport = async (values, token) =>
  await Axios.post(`${window.API}/site-visit`, values, {
    headers: { Authorization: `Bearer ${token}` },
  });

export { submitSiteVisitReport };
